import { DbRef } from '@caresend/types';
import { shouldEncryptDraftWaypointField } from './draftWaypoint.js';

/**
 * Determines if a value at a given path should be encrypted. Used primarily
 * for the dbSyncStore to determine if a value should be encrypted in the
 * database.
 *
 * @param updatePath - The path to the value.
 * @param value - The value to check.
 * @returns True if the value should be encrypted, false otherwise.
 */

const shouldEncryptValueAtPath = (updatePath, value) => {
  const [rootPath, id, childPath] = updatePath.split('/');
  if (!id || !childPath) return false;

  if (rootPath === DbRef.DRAFT_WAYPOINTS) {
    return shouldEncryptDraftWaypointField(childPath, value);
  }

  return false;
};

export { shouldEncryptValueAtPath };
